import React, { memo, useCallback, useState } from 'react'
import { ImportTouchDesk } from 'modules/ImortTouchDesk'
import { useProfileStore } from 'context/ProfileStore'
import { useHomeStore } from 'context/HomeStore'
import { format } from 'date-fns'
import generator from 'generate-password'
import ChangePasswordModal from './modals/ChangePassword.modal'
import ListUsersByIINModal from './modals/ListUsersByIIN.modal'
import { AuthService } from 'lib/api'
import { useResErrors } from 'hooks'
import { useEffect } from 'react'

const modalTypes = {
  password: 'password',
  listUsersByIIN: 'listUsersByIIN'
}

const ProfileFields = props => {
  const { profileStore, profileStoreFunc } = useProfileStore()
  const { homeStore } = useHomeStore()
  const { standardCheck } = useResErrors()
  const [users, setUsers] = useState([])
  const [openModals, setOpenModals] = useState({
    [modalTypes.password]: false,
    [modalTypes.listUsersByIIN]: false
  })
  const [usersByIIN, setUsersByIIN] = useState({
    loading: false,
    helperText: false,
    data: []
  })

  const getProjectCodeById = id => {
    if (id === 18) return 'CS'
    if (id === 3) return 'CP'

    return 'CS'
  }

  useEffect(() => {
    if (!!profileStore.user.managersProjectId)
      AuthService.getUsers({
        projectCode: getProjectCodeById(profileStore.user.managersProjectId),
        limit: 10000,
        isActive: true
      }).then(res =>
        standardCheck(
          res,
          () => {
            setUsers(res.data.userList || [])
          },
          {}
        )
      )
  }, [profileStore.user.managersProjectId])

  const onOpenModal = modal => () =>
    setOpenModals(prevState => ({
      ...prevState,
      [modal]: !prevState[modal]
    }))

  const getUsersByIIN = async () => {
    setUsersByIIN(prevState => ({
      ...prevState,
      loading: true
    }))

    await AuthService.getUsersByIIN(profileStore.user.iin).then(res => {
      const { data } = res
      const isArray = Array.isArray(data)

      setUsersByIIN(prevState => ({
        ...prevState,
        loading: false,
        data: isArray ? data : [],
        helperText: (isArray && data.length === 0) || typeof data === 'string'
      }))

      if (isArray && data.length > 0) {
        onOpenModal(modalTypes.listUsersByIIN)()
      }
    })
  }

  const onCloseUsersByIIN = () => {
    setUsersByIIN(prevState => ({
      ...prevState,
      data: []
    }))
    onOpenModal(modalTypes.listUsersByIIN)()
  }

  const onUploadAvatar = e => {
    const file = e.target.files[0]
    const data = new FormData()
    data.append('file', file)
    profileStoreFunc.uploadAvatar(data)
    e.preventDefault()
    e.target.value = ''
  }

  const onChange = useCallback(e => {
    let { name, value } = e.target
    if (['firstName', 'lastName'].includes(name)) {
      value = value?.trim()
    }
    if (name === 'branchCode') {
      profileStoreFunc.onChangeUser('subdivision', null)
    }

    profileStoreFunc.onChangeUser(name, value)
  }, [])

  const onChangeDate = date => {
    if (date?.toString() !== 'Invalid Date') {
      const value = format(new Date(date), 'dd.MM.yyyy')
      profileStoreFunc.onChangeUser('birthDate', value)
    }
  }

  const generatePass = () => {
    const pass = generator.generate({
      length: 6,
      numbers: true,
      strict: true
    })
    profileStoreFunc.onChangeUser('password', pass)
  }

  const onFocus = key => () => {
    const error = !!profileStore.validation?.profileFieldsErrors?.[key]
    if (error) {
      profileStoreFunc.validation.profileFieldsResetError(key)
    }
  }

  const rgv = users.filter(elem =>
    elem?.roles?.find(
      inner =>
        inner.code === 'HEAD_SALES' &&
        elem.id !== profileStore?.user?.id &&
        inner?.project?.id === profileStore?.user?.managersProjectId
    )
  )

  const rop = users.filter(elem =>
    elem?.roles?.find(
      inner =>
        (inner.code === 'SUPER_HEAD_SALES' ||
          inner.code === 'SUPER_HEAD_AND_BRANCH') &&
        elem.id !== profileStore?.user?.id &&
        inner?.project?.id === profileStore?.user?.managersProjectId
    )
  )

  const componentProps = {
    user: profileStore.user,
    rgv,
    rop,
    users: homeStore.users,
    isEdit: props.isEdit,
    onChange,
    onChangeDate,
    onChangePass: onOpenModal(modalTypes.password),
    generatePass,
    getUsersByIIN,
    usersByIIN,
    onUploadAvatar,
    errors: profileStore.validation?.profileFieldsErrors,
    onFocus,
    onSave: profileStoreFunc.onSave
  }

  return (
    <>
      <ImportTouchDesk
        desktop={() => import('./layout/ProfileFields.desktop')}
        touch={() => import('./layout/ProfileFields.mobile')}
      >
        {Component => <Component {...componentProps} />}
      </ImportTouchDesk>

      {openModals[modalTypes.password] && (
        <ChangePasswordModal
          username={profileStore.user?.username}
          open={openModals[modalTypes.password]}
          isEdit={props.isEdit}
          onChangePass={onOpenModal(modalTypes.password)}
          onClose={onOpenModal(modalTypes.password)}
          generatePass={generatePass}
        />
      )}

      {openModals[modalTypes.listUsersByIIN] && usersByIIN.data?.length > 0 && (
        <ListUsersByIINModal
          users={usersByIIN.data}
          open={openModals[modalTypes.listUsersByIIN]}
          onClose={onCloseUsersByIIN}
        />
      )}
    </>
  )
}

export default memo(ProfileFields)
